export const formatPhoneNumber = (number: string): string => {
    let formattedNumber = number
        .trim()
        .replace(/\s/g, '')
        .replace(/\(/g, '')
        .replace(/\)/g, '')
        .replace(/-/g, '')
        .replace(/^440/, '44');
    formattedNumber =
        formattedNumber[0] === '0' || formattedNumber[0] === '+'
            ? formattedNumber.slice(1)
            : formattedNumber;

    formattedNumber = formattedNumber.match(/^44/) ? formattedNumber : `44${formattedNumber}`;
    return formattedNumber;
};
